module.exports = ".action{\n  width: 10%;\n}\n\n.dropdown-menu{\n  left: unset;\n  right: 0;\n}\n\n.table-responsive{\n  overflow-x: unset;\n}\n\ni.fa.fa-cog {\n  font-size: 3rem;\n  cursor: pointer;\n  margin: 10px;\n}\n\n.dropdown-menu li {\n  border-bottom: 1px solid #eee;\n  padding: 5px 0px;\n}\n\n.dropdown-menu li:last-child{\n  border: 0px;\n}\n\ntextarea{\n  width: 100%;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/marketing/marketing.component.css
// module id = ./src/app/marketing/marketing.component.css
// module chunks = main